/**
 * Dashboard IP allowlist — redirect disallowed clients to the avatar (no login / access denied UI).
 */

export function isDashboardIpDeniedResponse(res, data = {}) {
  if (res?.status !== 403) return false;
  if (data?.code === 'ADMIN_IP_DENIED') return true;
  const msg = String(data?.error || '');
  return msg.toLowerCase().includes('access denied');
}

export function redirectToAvatar() {
  if (typeof window !== 'undefined') {
    window.location.replace('/');
  }
}

/**
 * @returns {Promise<boolean>} false if redirecting away from dashboard
 */
export async function ensureDashboardNetworkAccess(apiBase) {
  try {
    const res = await fetch(`${apiBase}/api/dashboard/access-check`);
    const data = await res.json().catch(() => ({}));
    // Only redirect when the server explicitly denies this IP — not on 5xx/proxy errors.
    if (data.allowed === false || isDashboardIpDeniedResponse(res, data)) {
      redirectToAvatar();
      return false;
    }
    return true;
  } catch {
    // Backend unreachable (e.g. dev server not running) — allow dashboard to load.
    return true;
  }
}

/**
 * Call after dashboard API fetch; redirects on IP denial.
 * @returns {boolean} true if redirected
 */
export function redirectIfDashboardIpDenied(res, data = {}) {
  if (isDashboardIpDeniedResponse(res, data)) {
    redirectToAvatar();
    return true;
  }
  return false;
}
